module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Sopranos-The-S2.aa0c097.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Sopranos-The-S2.jpg
// module id = lMrp
// module chunks = 0